import { useQuery } from '@tanstack/react-query';
import { httpClient, ROOT_URL } from '../../App';

export const useMetadataCountries = () => {
  const { data, refetch } = useQuery(
    ['/api/v1/worldCheck/countries'],
    async () => {
      const response = await httpClient.get(
        `${ROOT_URL}/api/v1/worldCheck/countries`
      );
      return response.data;
    }
  );

  const metadataCountries = (data || []).map((item: { value: string; label: string }) => ({
    value: item.value,
    label: item.label,
  }));

  return { metadataCountries, refetch };
};

